export enum TARGET_TYPE {
  SELF = '_self', // Abre o link na mesma janela/aba
  BLANK = '_blank', // Abre o link em uma nova janela/aba
  PARENT = '_parent', // Abre o link no frame pai
  TOP = '_top', // Abre o link no frame superior
}

export interface Link {
  url: string;
  label: string;
  isExternal?: boolean;
  target?: TARGET_TYPE;
}
